import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'

import { NoDataSvg } from 'components/Images'
import { colors, spaces } from 'global-parameters'

export default ({ className }) => {
  const contactMail = useStoreState((state) => state.config.contactMail)
  const mailto = `mailto:${contactMail}`

  return (
    <NoDataWrapper className={className}>
      <InfoWrapper>
        <NoDataSvg height={357} width={485} />
        <Title>No hay información sobre su proceso de evaluación</Title>
        <Description>
          Si usted tiene actividades que deben ser evaluadas y la
          <br />
          información no se muestra por favor contactar a
          <br />
          <a href={mailto}>{contactMail}</a>
        </Description>
      </InfoWrapper>
    </NoDataWrapper>
  )
}

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  height: 100%;
  width: 100%;
  border-radius: 8px;
  padding: ${spaces.m};
  > * + * {
    margin-top: ${spaces.l};
  }
  `

export const NoDataWrapper = styled.div`
  padding: ${spaces.m};
`

export const Title = styled.div`
  font-size: 21px;
  font-weight: 700;
  text-align: center;
  color: ${colors.black};
`

export const Description = styled.div`
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: ${colors.black};
  a {
    color: ${colors.blue};
    text-decoration: underline;
  }
`
